import React, { useContext } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import LoginPage from 'pages/LoginPage';
import CustomerPage from 'pages/CustomerPage';
import CustomerListPage from 'pages/CustomerListPage';
import { AuthContext } from 'auth/context';

const Routes: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);
  return (
    <Switch>
      <Route path="/login" component={LoginPage} />
      {!isAuthenticated && <Redirect to="/login" />}

      <Route path="/customers/:id" component={CustomerPage} />
      <Route path="/customers" component={CustomerListPage} />

      <Redirect from="/" to="/customers" />
    </Switch>
  );
};

export default Routes;
